import { Button2 } from "@/ui2/atoms/Button";
import { Card2 } from "@/ui2/atoms/Card";
import { cn } from "@/lib/helpers/cn";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getCurrentPolicyVersion } from "@/lib/helpers/getCurrentPolicyVersion";
import { getVersionedConsentHref } from "@/lib/helpers/getVersionedConsentHref";
import { Heading2 } from "@/ui2/atoms/Heading";
import { Link2 } from "@/ui2/atoms/Link";
import type { PolicyMetaData } from "@/core/types";

type ConsentAcpProps = {
  onSubmit: (response?: boolean) => Promise<void>;
  policyMetadata: PolicyMetaData;
};

export function ConsentToACP({ onSubmit, policyMetadata }: ConsentAcpProps) {
  const version = getCurrentPolicyVersion({ policy: "ADVANCED_CARE_PROGRAM", policyMetadata });
  const consentHref = getVersionedConsentHref({ policy: "advanced_care_program", version });

  return (
    <Card2 className={cn("tw:mx-auto tw:flex-col tw:gap-8 tw:p-12 tw:lg:max-w-148")}>
      <Heading2 as="h1" className="tw:text-center" size={4}>
        Review Advanced Care Program Consent
      </Heading2>

      <p className="body-md">
        Your insurance may cover additional services to support your care journey. By providing
        consent, you agree to participate in the{" "}
        <Link2 href={consentHref} isExternal>
          Advanced Care Program
        </Link2>
        . Your care team will determine if these services are right for you.
      </p>

      <div className="tw:flex tw:justify-between tw:gap-3">
        <Button2
          onPress={() => onSubmit(null)}
          size="lg"
          variant="text"
          {...getAutomationDataAttr("consent-to-acp-skip-button")}
        >
          Not now
        </Button2>

        <Button2
          className="tw:w-full"
          onPress={() => onSubmit(true)}
          size="lg"
          {...getAutomationDataAttr("consent-to-acp-acknowledge-and-continue-button")}
        >
          Acknowledge & Continue
        </Button2>
      </div>
    </Card2>
  );
}
